"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCreateProject = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
const typeguard_2 = require("../types/typeguard");
const isCreateProjectRuleSet = Object.assign(Object.assign({}, ProjectAction_1.baseProjectActionRuleSet), {
  type: value => value === 'CREATE_PROJECT',
  userId: typeguard_1.isString,
  projectId: typeguard_1.isString,
  sku: typeguard_1.isString,
  startingPageCount: (0, typeguard_1.optional)(typeguard_2.isNumber),
  startingProjectQuantity: (0, typeguard_1.optional)(typeguard_2.isNumber)
});
const isCreateProject = p => (0, typeguard_1.isType)(p, isCreateProjectRuleSet);
exports.isCreateProject = isCreateProject;